export const parsePan = (pan: string) => {
  return pan.split('_').join(' ').split(' ').join('');
};
